import {useMemo, useEffect, useCallback} from 'react'
import {useSelector, useDispatch} from 'react-redux'
import {
  setUniqueAddressessCount as setUniqueAddressessCountAction,
  clearUniqueAddressesCount as clearUniqueAddressesCountAction,
  setCurrentUniqueAddressesCount as setCurrentUniqueAddressesCountAction,
  selectUniqueAddressessCount
} from '../slices/uniqueAddressesCountSlice'
import {useStatesAndHealthConditions} from './breadCrumbs'
import uniqueAddressCountConfig from '../../appConfig/uniqueAddressesCount.config.json'
import {useConfig} from './config'

export const useUniqueAddressesCount = () => {
  const dispatch = useDispatch()
  const uniqueAddressessCount = useSelector(selectUniqueAddressessCount)
  const {filters} = useStatesAndHealthConditions()
  const defaultState = filters?.find((value) => value.key === 'state')?.default
  const {statesConfig} = useConfig() || {}

  useEffect(() => {
    if (defaultState?.includes(statesConfig?.entireUnitedStateLabel)) {
      dispatch(setUniqueAddressessCountAction(uniqueAddressCountConfig.entireUSUniqueAddressesCount))
    } else if (defaultState?.length > 1) {
      dispatch(setUniqueAddressessCountAction(uniqueAddressCountConfig.multiStateUniqueAddressesCount))
    } else {
      dispatch(setUniqueAddressessCountAction(uniqueAddressCountConfig.singleStateUniqueAddressesCount))
    }
  }, [defaultState, statesConfig, dispatch])

  const setUniqueAddressessCount = useCallback(
    (count) => {
      dispatch(setUniqueAddressessCountAction(count))
    },
    [dispatch]
  )

  const clearUniqueAddressesCount = useCallback(() => {
    dispatch(clearUniqueAddressesCountAction())
  }, [dispatch])

  const setCurrentUniqueAddressesCount = useCallback(
    (count) => {
      dispatch(setCurrentUniqueAddressesCountAction(count))
    },
    [dispatch]
  )

  return useMemo(
    () => ({
      uniqueAddressessCount,
      setUniqueAddressessCount,
      clearUniqueAddressesCount,
      setCurrentUniqueAddressesCount
    }),
    [uniqueAddressessCount, setUniqueAddressessCount, clearUniqueAddressesCount, setCurrentUniqueAddressesCount]
  )
}
